import React from 'react';

function EmptyTodos() {
  return <p>¡Agrega tu primer anime! 🥳🥳</p>;
}

export { EmptyTodos };